export type TProduct = {
  id: number;
  offerType: TProductOfferType;
  extra: {
    type: EProductType;
    name: string;
    uniquePromoId: string;
  };
};

export enum EProductType {
  Discount = 'discount',
  Mortgage = 'mortgage',
  Bonus = 'bonus',
  MilitaryMortgage = 'military_mortgage',
  MaternalCapital = 'maternal_capital',
  CianMortgage = 'cian_mortgage',
}

export type TProductOfferType = 'promo';
